export const useModelsMatrix = () => {
  const matrix = {
    'gas' : {
        'services': {
            '1': {
                'persons': {
                    '1': ['mg-10','maximus-advance-g-10','maximus-advance-wifi-g-10','fortis-g10','poderus-06','poderus-advance-06','fortis-paso-06','plenus-07','fortis-06','fortis-s-06'],
                    '2': ['mg-15','maximus-advance-g-15','maximus-advance-wifi-g-15','fortis-g15','poderus-09','poderus-advance-09','fortis-paso-09','plenus-07','fortis-s-09'],
                    '3': ['mg-15','maximus-advance-g-15','maximus-advance-wifi-g-15','fortis-g15','poderus-09','poderus-advance-09','fortis-paso-09','plenus-11','fortis-s-09'],
                    '4': ['mg-15','maximus-advance-g-15','maximus-advance-wifi-g-15','fortis-g15','poderus-09','poderus-advance-09','fortis-paso-09','plenus-11','fortis-s-09'],
                    '5': ['mg-15','maximus-advance-g-15','maximus-advance-wifi-g-15','fortis-g15','poderus-11','poderus-advance-11','fortis-paso-09','plenus-11','fortis-s-09'],
                    '6': ['mg-15','maximus-advance-g-15','maximus-advance-wifi-g-15','fortis-g15','poderus-11','poderus-advance-11','fortis-paso-09','plenus-11','fortis-s-09']
                }
            },
            '2': {
                'persons': {
                    '1': ['mg-15','maximus-advance-g-15','maximus-advance-wifi-g-15','fortis-g15','poderus-09','poderus-advance-09','fortis-paso-09','plenus-11','fortis-06','fortis-s-09'],
                    '2': ['mg-20','maximus-advance-g-20','maximus-advance-wifi-g-20','fortis-g20','poderus-11','poderus-advance-11','fortis-paso-11','plenus-13','plenus-advance-14','fortis-s-11'],
                    '3': ['mg-20','maximus-advance-g-20','maximus-advance-wifi-g-20','fortis-g20','poderus-11','poderus-advance-11','fortis-paso-11','plenus-13','plenus-advance-14','fortis-s-11'],
                    '4': ['mg-20','maximus-advance-g-20','maximus-advance-wifi-g-20','fortis-g20','poderus-11','poderus-advance-11','fortis-paso-11','plenus-13','plenus-advance-14','fortis-s-11'],
                    '5': ['mg-20','maximus-advance-g-20','maximus-advance-wifi-g-20','fortis-g20','poderus-11','poderus-advance-11','fortis-paso-11','plenus-13','plenus-advance-14','fortis-s-11'],
                    '6': ['mg-20','maximus-advance-g-20','maximus-advance-wifi-g-20','fortis-g20','poderus-11','poderus-advance-11','fortis-paso-11','plenus-13','plenus-advance-14','fortis-s-11']
                }
            },
            '3': {
                'persons': {
                    '1': ['mg-20','maximus-advance-g-20','maximus-advance-wifi-g-20','fortis-g20','poderus-11','poderus-advance-11','fortis-paso-11','plenus-13','fortis-06','fortis-s-11'],
                    '2': ['mg-20','maximus-advance-g-20','maximus-advance-wifi-g-20','fortis-g20','poderus-11','poderus-advance-11','fortis-paso-11','plenus-13','plenus-advance-14','fortis-s-11'],
                    '3': ['mg-30','maximus-advance-g-30','maximus-advance-wifi-g-30','fortis-g30','poderus-15','poderus-advance-11','fortis-paso-11','plenus-advance-16'],
                    '4': ['mg-30','maximus-advance-g-30','maximus-advance-wifi-g-30','fortis-g30','poderus-15','poderus-advance-11','fortis-paso-11','plenus-advance-16'],
                    '5': ['mg-30','maximus-advance-g-30','maximus-advance-wifi-g-30','fortis-g30','poderus-15','poderus-advance-11','fortis-paso-11','plenus-advance-16'],
                    '6': ['mg-30','maximus-advance-g-30','maximus-advance-wifi-g-30','fortis-g30','poderus-15','poderus-advance-11','fortis-paso-11','plenus-advance-16']
                }
            },
            '4': {
                'persons': {
                    '1': ['mg-20','maximus-advance-g-20','maximus-advance-wifi-g-20','fortis-g20','poderus-06','poderus-advance-06','fortis-paso-06','plenus-07','fortis-06','fortis-s-09'],
                    '2': ['mg-20','maximus-advance-g-20','maximus-advance-wifi-g-20','fortis-g20','poderus-11','poderus-advance-11','fortis-paso-11','plenus-13','plenus-advance-14','fortis-s-11'],
                    '3': ['mg-30','maximus-advance-g-30','maximus-advance-wifi-g-30','fortis-g30','poderus-20','poderus-advance-06','fortis-paso-06','plenus-advance-16','fortis-e06','fortis-s-11'],
                    '4': ['mg-40','maximus-advance-g-40','fortis-g40','poderus-20','plenus-advance-24'],
                    '5': ['mg-40','maximus-advance-g-40','fortis-g40','poderus-20','plenus-advance-24'],
                    '6': ['mg-40','maximus-advance-g-40','fortis-g40','poderus-20','plenus-advance-24']
                }
            },
            '5': {
                'persons': {
                    '1': ['mg-20','maximus-advance-g-20','maximus-advance-wifi-g-20','fortis-g20','poderus-11','poderus-advance-06','fortis-paso-06','plenus-07','fortis-e06','fortis-s-09'],
                    '2': ['mg-20','maximus-advance-g-20','maximus-advance-wifi-g-20','fortis-g20','poderus-11','poderus-advance-11','fortis-paso-11','plenus-13','plenus-advance-14','fortis-s-11'],
                    '3': ['mg-30','maximus-advance-g-30','maximus-advance-wifi-g-30','fortis-g30','poderus-15','poderus-advance-11','fortis-paso-11','plenus-advance-16','fortis-e06','fortis-s-11'],
                    '4': ['mg-40','maximus-advance-g-40','fortis-g40','poderus-20','plenus-advance-24'],
                    '5': ['mg-60','maximus-advance-g-60','fortis-e06','fortis-s-09','fortis-s-11'],
                    '6': ['mg-60','maximus-advance-g-60','fortis-e06','fortis-s-09','fortis-s-11']
                }
            },
            '6': {
                'persons': {
                    '1': ['mg-20','maximus-advance-g-20','maximus-advance-wifi-g-20','fortis-g20','poderus-11','poderus-advance-06','fortis-paso-06','plenus-07','fortis-e06','fortis-s-06'],
                    '2': ['mg-20','maximus-advance-g-20','maximus-advance-wifi-g-20','fortis-g20','poderus-11','poderus-advance-11','fortis-paso-11','plenus-13','plenus-advance-14','fortis-s-11'],
                    '3': ['mg-30','maximus-advance-g-30','maximus-advance-wifi-g-30','fortis-g30','poderus-15','poderus-advance-11','fortis-paso-11','plenus-advance-16','fortis-e06','fortis-s-11'],
                    '4': ['mg-40','maximus-advance-g-40','fortis-g40','poderus-20','plenus-advance-24'],
                    '5': ['mg-60','maximus-advance-g-60'],
                    '6': ['mg-60','maximus-advance-g-60']
                }
            }
        }
    },
    'electric' : {
        'services': {
            '1': {
                'persons': {
                    '1': ['e-10','pro-40-l', 'pro-advance-40', 'levittas-45','fortis-e10', 'levare-advance-30l', 'eleva-9'],
                    '2': ['e-15','pro-50-l', 'pro-advance-50', 'levittas-45','fortis-e15'],
                    '3': ['e-15','pro-50-l', 'pro-advance-50', 'levittas-45','fortis-e15'],
                    '4': ['e-15','pro-50-l', 'pro-advance-50', 'levittas-45','fortis-e15'],
                    '5': ['e-15','pro-50-l', 'pro-advance-50', 'levittas-45','fortis-e15'],
                    '6': ['e-15','pro-50-l', 'pro-advance-50', 'levittas-45','fortis-e15']
                }
            },
            '2': {
                'persons': {
                    '1': ['e-15','pro-40-l', 'pro-advance-40', 'levittas-45','fortis-e10', 'eleva-9'],
                    '2': ['e-20','pro-80-l', 'pro-advance-80', 'levittas-65','fortis-e20', 'eleva-pro-15'],
                    '3': ['e-20','pro-80-l', 'pro-advance-80', 'levittas-65','fortis-e20', 'eleva-pro-15'],
                    '4': ['e-20','pro-80-l', 'pro-advance-80', 'levittas-65','fortis-e20', 'eleva-pro-15'],
                    '5': ['e-20','pro-80-l', 'pro-advance-80', 'levittas-65','fortis-e20', 'eleva-pro-15'],
                    '6': ['e-20','pro-80-l', 'pro-advance-80', 'levittas-65','fortis-e20', 'eleva-pro-15']
                }
            },
            '3': {
                'persons': {
                    '1': ['e-20','pro-40-l', 'pro-advance-40', 'levittas-45','fortis-e10', 'eleva-9'],
                    '2': ['e-20','pro-80-l', 'pro-advance-80', 'levittas-65','fortis-e20', 'eleva-pro-15'],
                    '3': ['e-30','fortis-e30'],
                    '4': ['e-30','fortis-e30'],
                    '5': ['e-30','fortis-e30'],
                    '6': ['e-30','fortis-e30']
                }
            },
            '4': {
                'persons': {
                    '1': ['e-20','pro-40-l', 'pro-advance-40', 'levittas-45','fortis-e10', 'eleva-9'],
                    '2': ['e-20','pro-80-l', 'pro-advance-80', 'levittas-65','fortis-e20', 'eleva-pro-15'],
                    '3': ['e-30','fortis-e30'],
                    '4': ['e-40'],
                    '5': ['e-40'],
                    '6': ['e-40']
                }
            },
            '5': {
                'persons': {
                    '1': ['e-20','pro-40-l', 'pro-advance-40', 'levittas-45','fortis-e10', 'eleva-9'],
                    '2': ['e-20','pro-80-l', 'pro-advance-80', 'levittas-65','fortis-e20', 'eleva-pro-15'],
                    '3': ['e-30','fortis-e30'],
                    '4': ['e-40'],
                    '5': ['e-40'],
                    '6': ['e-40']
                }
            },
            '6': {
                'persons': {
                    '1': ['e-20','pro-40-l', 'pro-advance-40', 'levittas-45','fortis-e10', 'eleva-9'],
                    '2': ['e-20','pro-80-l', 'pro-advance-80', 'levittas-65','fortis-e20', 'eleva-pro-15'],
                    '3': ['e-30','fortis-e30'],
                    '4': ['e-40'],
                    '5': ['e-60'],
                    '6': ['e-60']
                }
            }
        }
    },
    'sun' : {
        'services': {
            '1': {
                'persons': {
                    '1': ['calorex-solar-sl-150', 'calorex-fortis-8-tubos-evacuados' ],
                    '2': ['calorex-solar-sl-150', 'calorex-fortis-solar-10-tubos'],
                    '3': ['calorex-solar-sl-150', 'fortis-solar-12-tubos'],
                    '4': ['calorex-solar-sl-240', 'fortis-solar-15-tubos'], 
                    '5': ['calorex-solar-sl-240', 'fortis-solar-20-tubos'],
                    '6': ['calorex-solar-sl-240', 'fortis-solar-20-tubos']
                }
            },
            '2': {
                'persons': {
                    '1': ['calorex-solar-sl-150', 'calorex-fortis-solar-10-tubos'],
                    '2': ['calorex-solar-sl-150', 'calorex-fortis-solar-10-tubos'],
                    '3': ['calorex-solar-sl-150', 'fortis-solar-12-tubos'],
                    '4': ['calorex-solar-sl-240', 'fortis-solar-15-tubos'],
                    '5': ['calorex-solar-sl-240', 'fortis-solar-20-tubos'],
                    '6': ['calorex-solar-sl-240', 'fortis-solar-20-tubos']
                }
            },
            '3': {
                'persons': {
                    '1': ['calorex-solar-sl-150', 'fortis-solar-12-tubos'],
                    '2': ['calorex-solar-sl-150', 'fortis-solar-12-tubos'],
                    '3': ['calorex-solar-sl-150', 'fortis-solar-12-tubos'],
                    '4': ['calorex-solar-sl-240', 'fortis-solar-15-tubos'],
                    '5': ['calorex-solar-sl-240', 'fortis-solar-20-tubos'],
                    '6': ['calorex-solar-sl-240', 'fortis-solar-20-tubos']
                }
            },
            '4': {
                'persons': {
                    '1': ['calorex-solar-sl-150', 'fortis-solar-15-tubos'],
                    '2': ['calorex-solar-sl-150', 'fortis-solar-15-tubos'],
                    '3': ['calorex-solar-sl-150', 'fortis-solar-15-tubos'],
                    '4': ['calorex-solar-sl-240', 'fortis-solar-15-tubos'],
                    '5': ['calorex-solar-sl-240', 'fortis-solar-20-tubos'],
                    '6': ['calorex-solar-sl-240', 'fortis-solar-20-tubos']
                }
            },
            '5': {
                'persons': {
                    '1': ['calorex-solar-sl-150', 'fortis-solar-20-tubos'],
                    '2': ['calorex-solar-sl-150', 'fortis-solar-20-tubos'],
                    '3': ['calorex-solar-sl-150', 'fortis-solar-20-tubos'],
                    '4': ['calorex-solar-sl-240', 'fortis-solar-20-tubos'],
                    '5': ['calorex-solar-sl-240', 'fortis-solar-20-tubos'],
                    '6': ['calorex-solar-sl-240', 'fortis-solar-20-tubos']
                }
            },
            '6': {
                'persons': {
                    '1': ['calorex-solar-sl-150', 'fortis-solar-20-tubos'],
                    '2': ['calorex-solar-sl-150', 'fortis-solar-20-tubos'],
                    '3': ['calorex-solar-sl-150', 'fortis-solar-20-tubos'],
                    '4': ['calorex-solar-sl-240', 'fortis-solar-20-tubos'],
                    '5': ['calorex-solar-sl-240', 'fortis-solar-20-tubos'],
                    '6': ['calorex-solar-sl-240', 'fortis-solar-20-tubos']
                }
            }
        }
    }
    };
  return matrix
}